import { useSnackbar } from "notistack";
import { backendPatch } from "@accredo/fe-shared/services/dataService.js";

export function useSparteActions() {
  const { enqueueSnackbar } = useSnackbar();

  /**
   * Only the description is editable; the name belongs to OpenViva.
   *
   * @returns {Promise<Object|null>} the updated Sparte resource
   */
  const updateDescription = async (sparte_id, beschreibung, options) => {
    const { setIsLoading } = options || {};

    return await backendPatch(`data/sparten/${sparte_id}`, {
      label: "Sparte speichern",
      toSend: { beschreibung },
      setIsLoading,
      enqueueSnackbar,
      successMessage: "Beschreibung gespeichert",
    });
  };

  return { updateDescription };
}
